import { connect } from 'react-redux';
import { endStudentObservation } from '../actions/observations';
import ObserveStudent from '../components/ObserveStudent';

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = {
	endStudentObservation
};

module.exports = connect(mapStateToProps, mapDispatchToProps)(ObserveStudent);



// WEBPACK FOOTER //
// ./frontend/olos/js/containers/ObserveStudent.jsx